import { render, staticRenderFns } from "./AttackDirection.vue?vue&type=template&id=197be053&scoped=true"
import script from "./AttackDirection.vue?vue&type=script&lang=js"
export * from "./AttackDirection.vue?vue&type=script&lang=js"
import style0 from "./AttackDirection.vue?vue&type=style&index=0&id=197be053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197be053",
  null
  
)

export default component.exports